import { useEffect, useState } from 'react';

//helpers
import { isLightColor } from  '@/helpers/Colours';
import { getTrialDaysLeft } from  '@/helpers/Date';

//components
import { BasicButton, IconLibrary, ThriveIcon, ThriveModal} from 'thrive-components';
import AppStoreButtonPanel from  '@/components/elements/appStore/appStoreButtonPanel';

//interfaces
import { ISelfSignUpTrial } from  '@/interfaces/selfSignUpTrial';

//styling
import "../../../css/SelfSignUpTrial/SelfSignUpTrial.scss";



const SelfSignUpTrial = ({createDate, orgName, brandColor}: ISelfSignUpTrial) => {
    const [showSelfSignUpTrialModal, setShowSelfSignUpTrialModal] = useState<boolean>(false);
    const isLight = isLightColor(brandColor);
    const daysLeft = getTrialDaysLeft(createDate);
    if (!daysLeft) {
        return <></>
    }
    return (
        <>
        <BasicButton 
            className='self-sign-up-trial-button'
            content={<>
                <ThriveIcon 
                    iconName={IconLibrary.CLOCK}
                    color='var(--thriveWhite)'
                    sizeInPx='12'
                    className='trial-clock-icon'    
                />
                {daysLeft}
                <span className='days-left'>Days left</span>
            </>} 
            ariaLabel={'Show Self Sign Up Modal'}
            onButtonClick={() => setShowSelfSignUpTrialModal(!showSelfSignUpTrialModal)}
        />

        <ThriveModal 
            className='self-sign-up-trial-modal'
            showModal={showSelfSignUpTrialModal} 
            onCloseClick={()=>setShowSelfSignUpTrialModal(false)}      
            headerContent={<h1>Your Trial is Active</h1>} 
            bodyContent={<div>
                <h2>Download Thrive</h2>
                
                <span>Get the Thrive app on your phone to see your customised workspace</span>

                <AppStoreButtonPanel />

                <h3>Get help onboarding</h3>
                
                <span>Book a call with our team to learn more about Thrive and get started</span>
                
                <BasicButton 
                    className='schedule-button'
                    ariaLabel={'Schedule a call with our team'}
                    onButtonClick={() =>window.open("https://calendly.com/thrive-app-sales/15-minute-discovery-call-free-trial", "_blank", "noopener,noreferrer")}
                    content={<>
                        <ThriveIcon 
                            iconName={IconLibrary.OLD_PHONE}
                            color='var(--thriveCharcoal)'
                            sizeInPx='14'
                            className='schedule-phone-icon'
                        />
                        Schedule a call
                    </>} 
                />
            </div>} 
            footerContent={  
                <div className="org-information-panel" style={{ "--brandColor": brandColor, "--brandFontColor": isLight ? "#343D4C" : "#ffffff" } as React.CSSProperties}>
                    <h4>YOUR ORGANISATION NAME</h4>

                    <span className="org-name">
                        {orgName}
                    </span>

                    <p className="org-instructions">
                        When you open the Thrive app for the first time, enter 
                            <span className="org-name-background">
                                <span>{orgName}</span> 
                            </span>
                        as your Organisation name to access your customised workspace.
                    </p>
                </div>
            }   
        />
        </>
    )
};

export default SelfSignUpTrial;
